/**
 * Error thrown when the datafusion Arrow-Flight WebSocket returns an error
 * frame. Carries the optional stable `code` the server now includes
 * (SCRUM-813 / SCRUM-800) alongside the human-readable message, so callers can
 * branch on the code instead of parsing the description. `code` is `undefined`
 * for legacy servers that predate the unified error-code envelope, in which
 * case behavior is unchanged.
 */
export class ArrowError extends Error {
  /** Stable, machine-readable error code from the server, if present. */
  readonly code?: string;
  /** Coarse error category from the frame's `error` field, if present. */
  readonly errorType?: string;

  constructor(message: string, frame?: { code?: unknown; error?: unknown }) {
    super(message);
    this.name = 'ArrowError';
    const code = frame?.code;
    const errorType = frame?.error;
    this.code = typeof code === 'string' ? code : undefined;
    this.errorType = typeof errorType === 'string' ? errorType : undefined;
    // Preserve the prototype chain so `instanceof ArrowError` works regardless
    // of the TS compilation target.
    Object.setPrototypeOf(this, ArrowError.prototype);
  }
}
